import React from "react";
import StandAloneContent from "../components/pages/Dashboard/StandAloneContent";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const StandAloneContentLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <StandAloneContent />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default StandAloneContentLayout;